import React, { useContext } from 'react'
import { useSelectpicker } from '../../utils/useSelectpicker'
import { FormContext } from './FormContext'

export type SelectProps = React.DetailedHTMLProps<React.SelectHTMLAttributes<HTMLSelectElement>, HTMLSelectElement> & {
  label: string
  options: [string, string][]
}

const Select: React.FC<SelectProps> = ({ label, options, ...props }) => {
  const { scope } = useContext(FormContext)
  const name = scope && props.name ? `${scope}[${props.name}]` : props.name
  const selectElement = useSelectpicker()

  return (
    <div className={['form-input-input', props.className].filter((x) => !!x).join(' ')}>
      <select name={name} className="form__select selectpicker" required ref={selectElement}>
        <option value="">{label}</option>
        {options.map(([value, label]) => (
          <option value={value} key={value}>
            {label}
          </option>
        ))}
      </select>
    </div>
  )
}

export default Select
